import Box from '@mui/material/Box'
import Settings from '@mui/icons-material/Settings'
import VideocamOutlined from '@mui/icons-material/VideocamOutlined'
import VideoLibrary from '@mui/icons-material/VideoLibrary'
import Delete from '@mui/icons-material/Delete'
import Stop from '@mui/icons-material/Stop'
import PlayArrow from '@mui/icons-material/PlayArrow'
import { useRoutes, type AppDispatch } from '../../../store'
import { EnrichedOutput } from '../../../api/nm-types'
import { Output, OutputAdminStatus } from '../../../../../common/src/api/v1/types'
import { DraftActions, draftOutputs, DraftSources, enableOutputs } from '../../../redux/actions/outputsActions'
import { OutputListDialog } from '.'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { ServiceOverviewButton } from '../../serviceOverview/Overview/index'
import { ActionMenu as BaseActionMenu } from '../../common/Table/ActionMenu'

interface ActionMenuProps {
  output: EnrichedOutput
  dispatch: AppDispatch
  showDialog: (output: Output, type: OutputListDialog) => void
}

export const ActionMenu = (props: ActionMenuProps) => {
  const { output, dispatch, showDialog } = props
  const routes = useRoutes()

  return (
    <Box sx={{ display: 'flex' }}>
      <ServiceOverviewButton input={output._input} outputId={output.id} />

      <BaseActionMenu
        data-test-id="output-action-menu"
        options={[
          {
            label: 'Edit',
            icon: <Settings />,
            href: routes.outputsUpdate({ id: output.id }),
            'data-test-id': 'edit-output',
          },
          {
            label: 'Switch input',
            icon: <VideocamOutlined />,
            onClick: () => {
              showDialog(output, OutputListDialog.selectInput)
            },
            'data-test-id': 'switch-input',
          },
          ...(output.adminStatus === OutputAdminStatus.on
            ? [
                {
                  label: 'Disable',
                  icon: <Stop />,
                  onClick: () => {
                    dispatch(
                      draftOutputs({
                        action: DraftActions.disable,
                        outputs: [output],
                        source: DraftSources.actionMenu,
                      }),
                    )
                  },
                  'data-test-id': 'toggle-admin-status-output',
                },
              ]
            : [
                {
                  label: 'Enable',
                  icon: <PlayArrow />,
                  onClick: () => {
                    dispatch(enableOutputs([output.id]))
                    dispatch(draftOutputs({ outputs: [] }))
                  },
                  'data-test-id': 'toggle-admin-status-output',
                },
              ]),
          {
            label: 'Add to list',
            icon: <VideoLibrary />,
            onClick: () => {
              showDialog(output, OutputListDialog.addToOutputList)
            },
            'data-test-id': 'add-to-list',
          },
          {
            label: 'Duplicate',
            icon: <ContentCopyIcon />,
            href: routes.outputsCopy({ id: output.id }),
            'data-test-id': 'use-output-as-template',
          },
          {
            label: 'Delete',
            icon: <Delete />,
            isDestructive: true,
            onClick: () => {
              dispatch(
                draftOutputs({ outputs: [output], action: DraftActions.delete, source: DraftSources.actionMenu }),
              )
            },
            'data-test-id': 'delete-output',
          },
        ]}
      />
    </Box>
  )
}
